import React from 'react';
import { useTranslation } from 'react-i18next';
import { FilterMinimalStyleCircle88 } from 'shared/assets/icons';
import { Icon } from 'shared/components/ui/icon';

import * as Styled from './smart-list-empty-state.style';

export const SmartListEmptyState: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Styled.NoFilterStateContainer>
      <Styled.IconContainer>
        <Icon icon={FilterMinimalStyleCircle88} />
      </Styled.IconContainer>
      <Styled.Title>
        {t('views.tasks-list.smart-list-empty-state.title')}
      </Styled.Title>
    </Styled.NoFilterStateContainer>
  );
};
